import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
// @ts-ignore
import { Reservation } from "@interfaces/reservation";
import { AdvancedFilters } from "@interfaces/advanced-filters";
import { MatSort, Sort } from "@angular/material/sort";
import { FilterComponent } from "@web/app/components/filter/filter.component";
import { MatDialog } from "@angular/material/dialog";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";
import { DWS } from "@interfaces/dws";
import { OrderStatusService } from "@services/dws";
import * as _ from "lodash";
import { DateIntervalComponent } from "@web/app/components/dialogs/date-interval/date-interval.component";
import { WinerySchedulingFilters } from "@services/dws/scheduling/page-scheduling/page-schedulings.service";
import { ActivatedRoute } from "@angular/router";
import { Login } from "@services/accounts.service";
import { access } from "@util/route/access";
import { observe } from "@web/util/loading/loading";
import { Observable, forkJoin, merge, of } from "rxjs";
import { WineryScheduling } from "@interfaces/dws/winery-scheduling";
import { parse } from "date-fns";
import { formatExperienceSlotCell, formatUtcTimestampCell, formatUtcTimestampLocal } from "@util/utc-timestamp";
import { TranslateDomainPipe } from "@web/app/pipes/translate/translate-domain.pipe";
import { MatPaginator } from "@angular/material/paginator";
import { map, pluck, tap } from "rxjs/operators";
import { WineryScheduleDatasource } from "@web/app/components/reservation-list/datasource/winery-schedule-datasource";
import { ReservationFilters } from "@interfaces/reservation-filters";
import { toast } from "@web/util/toast";
import { Moment } from "moment";
import { SchedulingService } from "@services/dws/scheduling/page-scheduling/page-schedulings.service";
import SchedulingExperience = WineryScheduling.SchedulingExperience;
import SchedulingRoom = WineryScheduling.SchedulingRoom;
import SchedulingEmployee = WineryScheduling.SchedulingEmployee;
import { SchedulingExportingService } from "@services/dws/scheduling/scheduling-exporting/scheduling-exporting.service";
import { ReservationExporting } from "@interfaces/dws/scheduling/reservation-exporting";
import { InfoIconHoverableComponent } from "../info-icon-hoverable/info-icon-hoverable.component";
import { VwReservation } from "@interfaces/dws/reservation";
import { locale } from "@util/locale";
import { HostReservationFormOptionsService } from "@services/host-reservation-form-options/host-reservation-form-options.service";
import { tr } from "@util/tr";
import { de, id } from "date-fns/locale";
import { state } from "@angular/animations";
import { HostReservationFormOptions } from "@services/host-reservation-form-options/host-reservation-form-options";
import { DWSFormOptions } from "@interfaces/dws/experience-dws";
import { WineryIntegrationsService } from "@services/dws/winery-integrations.service";
import { WineryIntegration } from "@interfaces/dws/integration";
marker("Filter does not return any result");

/* 'draft' | 'waiting' | 'confirmed' | 'revoked' | 'rejected' | 'completed' */
const weight: any = {
  waiting: -1,
  confirmed: 0,
  revoked: 3,
  completed: 1,
  rejected: 2,
  canceled: 4,
  draft: 99,
};

const compareStates = (a: Reservation, b: Reservation) => {
  if (a.aasm_state === b.aasm_state) return 0;
  const aState = a.aasm_state,
    bState = b.aasm_state;

  return weight[aState] - weight[bState];
};

@Component({
  selector: "app-reservation-list",
  templateUrl: "./reservation-list.component.html",
  styleUrls: ["./reservation-list.component.scss"],
})
export class ReservationListComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatSort) sort: MatSort = new MatSort();
  @ViewChild("paginatorTop") topPaginator!: MatPaginator;
  @ViewChild("paginatorBottom") bottomPaginator!: MatPaginator;

  _reservations: Reservation[] = [];
  dataSource!: WineryScheduleDatasource;
  appliedFilters: WinerySchedulingFilters = {
    state: ["confirmed", "waiting", "draft", "rejected", "completed", "canceled"],
  };
  storedFilters: WinerySchedulingFilters = {};
  orderStatus: DWS.OrderStatus[] = [];
  origins: Array<{id: string, name: string}> = [];
  rooms: SchedulingRoom[] = [];
  employees: SchedulingEmployee[] = [];
  experiencesTitle: SchedulingExperience[] = [];
  yesNoOptions: Array<{id: string, name: string}> = [];

  @Input() defaultFilters: {
    searchText?: string;
    draft: boolean;
    confirmed: boolean;
    waiting: boolean;
    rejected: boolean;
    completed: boolean;
    canceled: boolean;
    revoked: boolean;
  } = {
    draft: true,
    confirmed: true,
    waiting: true,
    rejected: false,
    completed: true,
    canceled: false,
    revoked: false,
  };
  @Output() reservationFilterEvent: EventEmitter<ReservationFilters> =
    new EventEmitter();

  @Output() winerySchedulingClick: EventEmitter<VwReservation> =
    new EventEmitter<VwReservation>();
  @Output() totalElementsChange: EventEmitter<number> =
    new EventEmitter<number>();
  displayedColumns: string[] = [
    "id",
    "experienceTitleIt",
    "masterContactName",
    "guestCountTotal",
    "createdAt",
    "date",
    "reservationOrigin",
    "origin",
    "state",
    "netTotalCents",
    "paid",
    "due",
    "paymentDate",
    "invoiceData",
    "isSales",
    "checkedIn",
  ];
  login: Login;
  lang!: string;
  page = 0;
  pageSize = 10;

  manualOrigins: any[] = [];

  manualOriginsNames: any[] = [];

  //reloadReservations = true;

  integrations: WineryIntegration[] = [];

  reservationOrigins: {id: number | string, name: string}[] = [];

  constructor(
    private dialog: MatDialog,
    private orderStatusService: OrderStatusService,
    private route: ActivatedRoute,
    private schedulingService: SchedulingService,
    private schedulingExportingService: SchedulingExportingService,
    private formOptionsService: HostReservationFormOptionsService,
    private integrationsService: WineryIntegrationsService
  ) {
    this.login = access(route).data("login");
    this.lang = locale().locale;
  }

  ngOnInit() {
    observe(
      forkJoin([
        this.orderStatusService.list(),
        this.schedulingService.getAdvancedFiltersElements(
          this.login.company.id
        ),
        this.formOptionsService.get(this.login.company.id, ""),
        this.integrationsService.getWineryIntegrations(this.login.company.id),
      ])
    ).subscribe(([orderStatus, schedulingFields, formOptions, integrations]) => {
      this.orderStatus = orderStatus;
      this.experiencesTitle = schedulingFields.experiences;
      this.origins = schedulingFields.origins.map((origin: string) => ({
        id: origin,
        name: origin
      }));
      
      this.rooms = schedulingFields.rooms;
      this.employees = schedulingFields.employees;
      
      this.yesNoOptions = [
        { id: 'yes', name: tr("Yes") },
        { id: 'no', name: tr("No") }
      ];
      this.manualOrigins = formOptions.manualOrigins;
      this.manualOriginsNames = this.manualOrigins
      .map(origin => {
        return { id: origin.nameEn, name: tr(origin.nameEn)};
      });

      this.integrations = integrations;
    });
    
    this.setupDataSource();
    this.dataSource.elementsSubject$.subscribe((total: number) => {
      this.totalElementsChange.emit(total || 0);
    });
  }

  ngAfterViewInit(): void {
    //clone default filters
    var clonedFilters = { ...this.defaultFilters };
    var searchText = clonedFilters.searchText;
    delete clonedFilters.searchText;

    // Initialize a new object to store the applied filters
    var newArr = {
      state: [] as string[],
      searchText,
    } as WinerySchedulingFilters;

    // Iterate over the cloned filters with explicit typing
    (Object.keys(clonedFilters) as (keyof typeof clonedFilters)[]).forEach(
      (key) => {
        if (clonedFilters[key]) {
          // TypeScript now knows that key is of the correct type
          newArr.state!.push(key as Reservation.State);
        }
      }
    );

    // Assign the filtered results to appliedFilters
    this.appliedFilters = newArr;
    this.sort.sortChange.subscribe(() => {
      this.bottomPaginator.pageIndex = 0;
      this.topPaginator.pageIndex = 0;
    });
    merge(this.sort.sortChange, this.bottomPaginator.page)
      .pipe(
        tap(() => {
          this.listWineryScheduling(
            this.bottomPaginator.pageIndex,
            this.pageSize,
            this.sortBy
          );
        })
      )
      .subscribe();
    this.listWineryScheduling(
      this.bottomPaginator.pageIndex,
      this.pageSize,
      this.sortBy
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultFilters) {
      this.appliedFilters = {
        state: this.builderFilter(this.defaultFilters),
        searchText: this.defaultFilters.searchText,
      };
      this.listWineryScheduling(0, this.pageSize, this.sortBy);
    }
  }

  public handlePageTop(e: any) {
    //let { pageSize } = e;
    ////this.bottomPaginator.pageSize = pageSize;
    //
    //if (!this.topPaginator.hasNextPage()) {
    //  this.bottomPaginator.lastPage();
    //} else if (!this.topPaginator.hasPreviousPage()) {
    //  this.bottomPaginator.firstPage();
    //} else {
    //  if (this.topPaginator.pageIndex < this.bottomPaginator.pageIndex) {
    //    this.bottomPaginator.previousPage();
    //  } else if (this.topPaginator.pageIndex > this.bottomPaginator.pageIndex) {
    //    this.bottomPaginator.nextPage();
    //  }
    //}
  }

  public handlePageBottom(e: any) {
    let { pageSize } = e;
    this.pageSize = pageSize;

    if (!this.bottomPaginator.hasNextPage()) {
      this.topPaginator.lastPage();
    } else if (!this.bottomPaginator.hasPreviousPage()) {
      this.topPaginator.firstPage();
    } else {
      if (this.bottomPaginator.pageIndex < this.topPaginator.pageIndex) {
        this.topPaginator.previousPage();
      } else if (this.bottomPaginator.pageIndex > this.topPaginator.pageIndex) {
        this.topPaginator.nextPage();
      }
    }
  }

  private setupDataSource() {
    this.dataSource = new WineryScheduleDatasource(this.schedulingService);
  }

  listWineryScheduling(
    page: number = 0,
    count: number = 50,
    sortBy: string = "createdAt,DESC"
  ) {
    this.dataSource.loadWineryScheduling(
      this.login.company.id,
      this.appliedFilters,
      page,
      count,
      sortBy
    );
  }

  generateInfoCall(reservation: DWS.WineryScheduling): Observable<String> {
    function convertArrayToString(
      value: DWS.SaleReservation.ParticipantsDetails[]
    ): String {
      let result: String = "";
      result = value
        .filter((item) => item.quantity !== undefined && item.quantity > 0) // Filter out items with quantity <= 0
        .map(
          (item) =>
            ` ${item.name}: ${item.quantity}`
        )
        .join("\r\n");

      return result;
    }
    return this.schedulingService.getPartecipantsDetails(reservation.id).pipe(
      map((value) => convertArrayToString(value)) // Apply linear transformation and convert to string
    );
  }

  total(reservation: Reservation): number {
    return Number(Reservation.total(reservation));
  }

  start_at(reservation: Reservation): Date {
    return parse(reservation.start_at, "yyyy-MM-dd", new Date());
  }

  rowClicked(ws: VwReservation) {
    this.winerySchedulingClick.emit(ws);
  }

  origin(reservation: Reservation): string {
    try {
      return reservation.order_row
        ? new URL(reservation.order_row?.origin).hostname
        : "";
    } catch (e) {
      return "";
    }
  }

  private experienceFilterLabel(experience: any): string {
    if (!experience) return "";
    const lang = (locale().locale || "en").toLowerCase();
    const current = experience[`title_${lang}`] || experience[`title${lang.charAt(0).toUpperCase()}${lang.slice(1)}`];
    if (typeof current === "string" && current.trim()) return current;
    const translated = TranslateDomainPipe.transform(experience, "title");
    if (translated && String(translated).trim()) return translated;
    return experience.title_en || experience.titleEn || experience.title_it || experience.titleIt || "";
  }

  openFilterDialog() {
    const advancedFilterFields: AdvancedFilters<WinerySchedulingFilters>[] = [
      {
        id: "reservationId",
        label: tr("ID Booking"),
        type: "text",
      },
      {
        id: "experienceId",
        label: tr("Experience"),
        type: "multiselect",
        options: this.experiencesTitle,
        name: (e) => this.experienceFilterLabel(e),
        match: (query, field, row) =>
          _.intersectionBy(query, [row.experience], "id").length > 0,
      },
      {
        id: "fullName",
        label: tr("Client Contact Name"),
        type: "text",
        match: (query, field, r) =>
          `${r.firstname} ${r.lastname}`
            .toLocaleLowerCase()
            .includes(query.toLocaleLowerCase()),
      },
      {
        id: "adults",
        label: tr("Partecipants"),
        type: "number",
      },
      {
        id: "dateRangeCreation",
        label: tr("Reservation date"),
        type: "date-interval",
        match: (query, field, r: VwReservation) =>
          AdvancedFilters.betweenDates(query, r.date?.toString()),
      },
      {
        id: "dateRange",
        label: tr("Experience date"),
        type: "date-interval",
        match: (query, field, r: VwReservation) =>
          AdvancedFilters.betweenDates(query, r.date?.toString()),
      },
      {
        id: "dateRangePaymentDate",
        label: tr("Payment date"),
        type: "date-interval",
        match: (query, field, r: VwReservation) =>
          AdvancedFilters.betweenDates(query, (r.paidAt || (r as any).otherData?.paidAt)?.toString?.()?.slice(0, 10)),
      },
      {
        id: "total",
        label: tr("Total"),
        type: "currency",
        match: (query, field, r: Reservation) =>
          AdvancedFilters.priceInRange(
            query,
            parseFloat(this.total(r).toString()) * 100
          ),
      },
      {
        id: "paid",
        label: tr("Paid Check"),
        type: "multiselect",
        options: this.yesNoOptions,
        name: (e: any) => {
          if (!e) return '';
          if (e.id === 'yes') return tr("Yes");
          if (e.id === 'no') return tr("No");
          return e?.name || String(e);
        },
        match: (query, field, r: VwReservation) => {
          if (!Array.isArray(query) || query.length === 0) return true;
          const yesSelected = query.some(q => q.id === 'yes');
          const noSelected = query.some(q => q.id === 'no');
          if (yesSelected && noSelected) return true;
          if (yesSelected) return r.paid === true;
          if (noSelected) return r.paid !== true;
          return true;
        },
      },
      {
        id: "reservationOrigin",
        label: tr("Origin"),
        type: "multiselect",
        options: [...this.manualOriginsNames, ...this.reservationOrigins],
        name: (e: any) => {
          if (!e) return '';
          return e?.name ? tr(e.name) : '';
        },
        compare: (a: any, b: any) => a?.id === b?.id,
      },
      {
        id: "origin",
        label: tr("Typology"),
        type: "multiselect",
        options: [...this.origins, { id: tr("Tour Operator"), name: tr("Tour Operator") }],
        name: (e: any) => e?.name || e?.id || String(e),
        compare: (a: any, b: any) => a?.id === b?.id,
      },
      {
        id: "roomId",
        label: tr("Rooms"),
        type: "multiselect",
        options: this.rooms,
        match: (query, field, row) =>
          _.intersectionBy(query, [row.room], "id").length > 0,
      },
      {
        id: "employeeId",
        label: tr("Employees"),
        type: "multiselect",
        options: this.employees,
        match: (query, field, row) =>
          _.intersectionBy(query, [row.employee], "id").length > 0,
        name: (e) => e.name,
      },
      {
        id: "invoiceRequest",
        label: tr("Invoice Request"),
        type: "multiselect",
        options: this.yesNoOptions,
        name: (e: any) => {
          if (!e) return '';
          if (e.id === 'yes') return tr("Yes");
          if (e.id === 'no') return tr("No");
          return e?.name || String(e);
        },
        match: (query, field, r: VwReservation) => {
          if (!Array.isArray(query) || query.length === 0) return true;
          const yesSelected = query.some(q => q.id === 'yes');
          const noSelected = query.some(q => q.id === 'no');
          if (yesSelected && noSelected) return true;
          const hasInvoice = !!r.otherData?.invoiceData && r.otherData.invoiceData !== '{}';
          if (yesSelected) return hasInvoice;
          if (noSelected) return !hasInvoice;
          return true;
        },
      },
      {
        id: "isSales",
        label: tr("isSales"),
        type: "multiselect",
        options: this.yesNoOptions,
        name: (e: any) => {
          if (!e) return '';
          if (e.id === 'yes') return tr("Yes");
          if (e.id === 'no') return tr("No");
          return e?.name || String(e);
        },
        match: (query, field, r: VwReservation) => {
          if (!Array.isArray(query) || query.length === 0) return true;
          const yesSelected = query.some(q => q.id === 'yes');
          const noSelected = query.some(q => q.id === 'no');
          if (yesSelected && noSelected) return true;
          if (yesSelected) return !!r.otherData?.isSales;
          if (noSelected) return !r.otherData?.isSales;
          return true;
        },
      },
      {
        id: "checkedIn",
        label: tr("checkedIn"),
        type: "multiselect",
        options: this.yesNoOptions,
        name: (e: any) => {
          if (!e) return '';
          if (e.id === 'yes') return tr("Yes");
          if (e.id === 'no') return tr("No");
          return e?.name || String(e);
        },
        match: (query, field, r: VwReservation) => {
          if (!Array.isArray(query) || query.length === 0) return true;
          const yesSelected = query.some(q => q.id === 'yes');
          const noSelected = query.some(q => q.id === 'no');
          if (yesSelected && noSelected) return true;
          if (yesSelected) return !!r.otherData?.checkedIn;
          if (noSelected) return !r.otherData?.checkedIn;
          return true;
        },
      },
    ];

    const dialog = this.dialog.open(FilterComponent, {
      width: "100%",
      minWidth: 850,
      maxWidth: 850,
      maxHeight: "90dvh",
      data: {
        appliedFilters: this.storedFilters,
        advancedFilterFields,
      },
    });

    dialog.afterClosed().subscribe((filters) => {
      if (!filters) return;

      let hadAppointment = false;

      if (filters.origin && filters.origin.some((o: any) => o.id === "APPUNTAMENTO")) {
        filters.type = ["appointment"];
        hadAppointment = true;
      }
      let filtersOrigin = filters.origin;
      if (filters.origin) {
        filters.origin = filters.origin.filter((o: any) => o.id !== "APPUNTAMENTO");
      }
      
      this.topPaginator.pageIndex = 0;
      this.bottomPaginator.pageIndex = 0;
      this.topPaginator.page.next({ pageIndex: 0, pageSize: this.pageSize, length: 0 });

      this.storedFilters = { ...filters };
      this.reservationFilterEvent.emit(filters);

      const processedFilters = { ...filters };

      if (processedFilters["total"]) {
        _.merge(processedFilters, {
          minTotal: processedFilters["total"].gte * 100,
          maxTotal: processedFilters["total"].lte * 100,
        });
        delete processedFilters["total"];
      }

      if (filters.reservationOrigin && Array.isArray(filters.reservationOrigin)) {
        processedFilters.reservationOrigin = filters.reservationOrigin.map((origin: {id: string, name: string}) => {
          const match = this.manualOrigins.find(m => m.nameEn === origin.id);

          return match ? match.id : origin.id;
        });
      }

      const cleanedFilters = _.pickBy(processedFilters, _.identity);

      Object.entries(cleanedFilters).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0 && _.has(value[0], "id")) {
          cleanedFilters[key] = _.join(_.map(value, "id"), ",");
        }
        else if (key === 'paid' || key === 'invoiceRequest' || key === 'isSales' || key === 'checkedIn') {
          if (Array.isArray(value) && value.length === 1) {
            cleanedFilters[key] = value[0].id === 'yes';
          } else if (Array.isArray(value) && value.length === 2) {
            delete cleanedFilters[key];
          }
        }
      });

      cleanedFilters.state = this.appliedFilters.state;
      this.appliedFilters = cleanedFilters;

      this.listWineryScheduling(0, this.pageSize, this.sortBy);

      if (hadAppointment && filtersOrigin) {
        const alreadyHas = filtersOrigin.some((o: any) => o.id === "APPUNTAMENTO");
        if (!alreadyHas) {
          filtersOrigin.push({ id: "APPUNTAMENTO", name: "Appuntamento" });
        }
      }

      filters.origin = filtersOrigin;
      this.storedFilters.origin = filtersOrigin;
      this.bottomPaginator.pageIndex = 0;

      this.dataSource.elementsSubject$.subscribe((e) => {
        if (!e) toast(tr("Filter does not return any result"));
      });
    });
  }

  get activeFiltersCount(): number {
    if (!this.storedFilters) return 0;
    
    let count = 0;
    Object.keys(this.storedFilters).forEach((key) => {
      if (key === 'state') return;
      
      const value = (this.storedFilters as any)[key];
      
      if (value !== null && value !== undefined) {
        if (Array.isArray(value) && value.length > 0) {
          count++;
        } else if (typeof value === 'object' && !Array.isArray(value)) {
          const hasValue = Object.values(value).some(v => v !== null && v !== undefined && v !== '');
          if (hasValue) count++;
        } else if (typeof value === 'string' && value.trim() !== '') {
          count++;
        } else if (typeof value === 'number') {
          count++;
        }
      }
    });
    
    return count;
  }

  filterByStatus(status: {
    confirmed?: boolean;
    waiting?: boolean;
    rejected?: boolean;
    revoked?: boolean;
    completed?: boolean;
  }) {
    const buildFilter = { state: this.builderFilter(status) };
    this.appliedFilters = { ...this.appliedFilters, ...buildFilter } as any;
    this.listWineryScheduling(0, this.pageSize, this.sortBy);
  }

  // openExportDialog() {
  //   const dialog = this.dialog.open(DateIntervalComponent, {
  //     width: "100%",
  //     minWidth: 650,
  //     maxWidth: 650,
  //     data: {
  //       title: tr("Experience date"),
  //       showFilterInfo: true,
  //       nFilters: this.countAppliedFilters(),
  //     },
  //   });

  //   dialog.afterClosed().subscribe((data) => {
  //     const start = (data.start as Moment).toDate();
  //     const end = (data.end as Moment).toDate();
  //     const type: "csv" | "xlsx" = data.type;
  //     const obs$ = this.schedulingService
  //       .list(
  //         this.login.company.id,
  //         { ...this.appliedFilters, startTime: start, endTime: end },
  //         0,
  //         999999,
  //         this.sortBy
  //       )
  //       .pipe(pluck("content"));
  //     const obs2$ = this.formOptionsService.get(this.login.company.id, "");
  //     observe(forkJoin([obs$, obs2$])).subscribe(
  //       ([schedulingExporting, formOptions]) => {
  //         switch (type) {
  //           case "csv":
  //             ReservationExporting.saveAsCSV(schedulingExporting, formOptions);
  //             break;
  //           case "xlsx":
  //             ReservationExporting.saveAsXLSX(schedulingExporting, formOptions);
  //             break;
  //         }
  //       }
  //     );
  //   });
  // }

  private countAppliedFilters(): any {
    let count = 0;
    if (this.appliedFilters) {
      Object.keys(this.appliedFilters).forEach((key) => {
        if (
          key !== "wineryCreatedAt" &&
          key !== "state" &&
          this.appliedFilters![key as keyof WinerySchedulingFilters]
        ) {
          count++;
        }
      });
    }
    return count;
  }

  public builderFilter(status: {
    revoked?: boolean;
    confirmed?: boolean;
    waiting?: boolean;
    rejected?: boolean;
    draft?: boolean;
    completed?: boolean;
    canceled?: boolean;
  }): Reservation.State[] {
    const statusArray: Array<Reservation.State> = [];
    if (status.confirmed) statusArray.push("confirmed" as Reservation.State);
    if (status.waiting) statusArray.push("waiting" as Reservation.State);
    if (status.canceled) statusArray.push("canceled" as Reservation.State);
    if (status.rejected) statusArray.push("rejected" as Reservation.State);
    if (status.revoked) statusArray.push("revoked" as Reservation.State);
    if (status.completed) statusArray.push("completed" as Reservation.State);
    if (status.draft) statusArray.push("draft" as Reservation.State);
    return statusArray;
  }

  centsInCurrency(cents: any = 0) {
    return Number(cents) / 100;
  }

  get sortBy() {
    if (this.sort.active === "reservationOrigin" && this.lang === "it") {
      return `${this.sort.active}It,${this.sort.direction.toUpperCase()}`;
    } else {
      return `${this.sort.active},${this.sort.direction.toUpperCase()}`;
    }
  }

  //showDetails(
  //  event: MouseEvent,
  //  isEntering: boolean,
  //  elementa: InfoIconHoverableComponent
  //): void {
  //  if (isEntering) {
  //    elementa.onMouseOverInternal(event);
  //  } else {
  //    elementa.onMouseOut(event);
  //  }
  //}

  /** WS-2190: Payment date display DD/MM/YYYY HH:mm. Returns empty for appointments or when not paid. */
  getReservationCreatedAtCell(r: VwReservation): { date: string; time?: string } | null {
    return formatUtcTimestampCell(r?.createdAt, { omitMidnightTime: false });
  }

  getExperienceDateCell(r: VwReservation): { date: string; time?: string } | null {
    // Experience slot is naive date+time (not a UTC instant like createdAt / paidAt).
    return formatExperienceSlotCell(r?.startDateTime, r?.date, r?.time, { omitMidnightTime: false });
  }

  private reservationPaidAt(r: VwReservation): string | Date | undefined {
    if (r.type === "appointment") {
      return undefined;
    }
    return r.paidAt || (r as { otherData?: { paidAt?: string } }).otherData?.paidAt;
  }

  getPaymentDateCell(r: VwReservation): { date: string; time?: string } | null {
    const paidAt = this.reservationPaidAt(r);
    if (!paidAt) {
      return null;
    }
    return formatUtcTimestampCell(paidAt, { omitMidnightTime: false });
  }

  /** WS-2190: Tooltip with date+time, or payment+refund for revoked. */
  getPaymentDateTooltip(r: VwReservation): string {
    if (r.type === "appointment") {
      return "";
    }
    const paidAt = this.reservationPaidAt(r);
    if (!paidAt) {
      return "";
    }
    const refundedAt = r.refundedAt || (r as { otherData?: { refundedAt?: string } }).otherData?.refundedAt;
    const paidStr = formatUtcTimestampLocal(paidAt, "dd/MM/yyyy HH:mm");
    if (!paidStr) {
      return "";
    }
    if (refundedAt) {
      const refStr = formatUtcTimestampLocal(refundedAt, "dd/MM/yyyy HH:mm");
      const amountStr = this.formatRefundedAmount(r);
      return `${tr("Paid")}: ${paidStr}\n${tr("Refunded")}: ${refStr}${amountStr ? ` (${amountStr})` : ""}`;
    }
    return paidStr;
  }

  private formatRefundedAmount(r: VwReservation): string {
    const cents = r.refundedTotalCents ?? (r as any).otherData?.refundedTotalCents ?? 0;
    if (!cents) return "";
    const currency = r.paymentCurrency || "EUR";
    try {
      return (cents / 100).toLocaleString(undefined, { style: "currency", currency });
    } catch {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  }

  getMasterContactName(reservation: VwReservation): string {
    const contact = reservation.reservationContacts?.find(
      (c) => c.contact_type === "MASTER"
    );
    if (!contact) return "";
    return (contact.first_name || "") + " " + (contact.last_name || "");
  }

  getExperienceName(reservation: VwReservation): string {
    if (
      !reservation.experienceTranslations ||
      !Array.isArray(reservation.experienceTranslations)
    )
      return "";

    const result = this.getTitle(reservation);
    return result;
  };

  getTitle = (reservation: VwReservation): string => {
    const currentLang = this.lang || "en";
    let translation = reservation.experienceTranslations?.find(
      (t) => t.translation_id === "TITLE"
    )?._translations;

    if (translation) {
      // Try current language
      if (translation[currentLang]) {
        return translation[currentLang];
      }

      // Fallback to English
      if (translation["en"]) {
        return translation["en"];
      }

      // Fallback to Italian
      if (translation["it"]) {
        return translation["it"];
      }

      // Fallback to first available translation
      const translations = Object.values(translation);
      const firstAvailable = translations.find(
        (val) => typeof val === "string" && val.trim() !== ""
      );
      if (firstAvailable && typeof firstAvailable === "string") {
        return firstAvailable;
      }
    }

    return "";
  };

  statusFn(wineryScheduling: any) {
    if (wineryScheduling.state?.toLowerCase() == "completed") {
      return "completed";
    }
    if (wineryScheduling.state?.toLowerCase() == "canceled") {
      return "canceled";
    }
    return wineryScheduling.state;
  }

  statusBgColorFn(wineryScheduling: any) {
    if (wineryScheduling.state?.toLowerCase() == "completed") {
      return "success_dark";
    }
    if (wineryScheduling.state?.toLowerCase() == "confirmed") {
      return "success";
    }
    if (wineryScheduling.state?.toLowerCase() == "canceled") {
      return "danger";
    }
    if (wineryScheduling.state?.toLowerCase() == "rejected") {
      return "danger";
    }
    if (wineryScheduling.state?.toLowerCase() == "revoked") {
      return "danger";
    }
    if (wineryScheduling.state?.toLowerCase() == "waiting") {
      return "warning";
    }
    if (wineryScheduling.state?.toLowerCase() == "draft") {
      return "draft";
    }

    return "secondary";
  }

  getOrigin(origin: any): any {
    if (!!!origin) {
      return "";
    }
    var originFormatted =
      ""  +
      origin.origin
        ?.replace("https://", "")
        .replace("http://", "")
        .replace("www.", "")
        .replace(/\:\d+/g, "")
        .toLowerCase();
    if (
      origin.origin !== "" &&
      (("" + origin.origin).toLocaleLowerCase().indexOf("manual") > -1 ||
      "Wine Suite".indexOf(origin.origin) > -1)
    ) {
      originFormatted = "Manual Reservation";
    }
    if (originFormatted !== "") {
      originFormatted = originFormatted;
    }
    if (origin.manualOriginId) {
      const manualOrigin = this.manualOrigins.find((o) => o.id === origin.manualOriginId);
      if (manualOrigin) {
        originFormatted = manualOrigin.nameEn;
      }
    }
    if (origin.otherData && origin.otherData.origin !== undefined && origin.otherData.origin !== "") {
      originFormatted = origin.otherData.origin;
    }

    const reservationOrigin =
      (originFormatted !== "" && originFormatted !== undefined && originFormatted !== "undefined")
        ? { id: originFormatted, name: tr(originFormatted) }
        : (origin.origin !== "" && origin.origin !== undefined && origin.origin !== "undefined")
          ? { id: origin.origin, name: tr(origin.origin) }
          : { id: "Not specified feminine", name: tr("Not specified feminine") };

    const alreadyInManual = this.manualOriginsNames.find((o) => o.id === reservationOrigin.id);

    const alreadyExists = this.reservationOrigins.some(
      obj => obj.id === reservationOrigin.id
    );

    if (!alreadyExists && !alreadyInManual) {
      this.reservationOrigins.push(reservationOrigin);
    }

    return reservationOrigin.id;
  }

  getTypology(r: any): any {
    if(r.type === 'appointment'){
      return tr("Appointment");
    }
    const origin = r.origin;
      if (!origin){
        if (r.type === 'manual') {
        return tr("manual entry");
      }
        return '';
    }
    // legacy check for integrations that were set to manual before 30/6/25 - gyg, winedering, manava
      if(r.type === 'manual'){
        if (origin.toLocaleLowerCase().includes('gyg')) return tr("gyg");
        if (origin.toLocaleLowerCase().includes('winedering')) return tr("Winedering");
        if (origin.toLocaleLowerCase().includes('manava')) return tr("Manava");
    }
      var originFormatted = "" + origin?.replace("https://", "").replace("http://", "").replace("www.", "").replace(/\:\d+/g, "").toLowerCase();
      if (("" + origin).toLocaleLowerCase().indexOf("manual") > -1 || "Wine Suite".indexOf(origin) > -1) {
      originFormatted = tr("manual entry");
    }
    originFormatted = tr(originFormatted);
      return originFormatted ? originFormatted : (origin ? tr(origin) : "");
  }

  /* onSortChange(sortState: Sort) {
    if (sortState.active === 'reservationOrigin' || sortState.active === 'origin') {
      this.dataSource.setSort(sortState);
      this.reloadReservations = false;
    } else {
      this.reloadReservations = true;
    }
  } */
}